export const PLATFORM = {
    DESKTOP: 'DESKTOP',
    WEB: 'WEB',
    ANDROID: 'ANDROID'
};
